import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import { PRIVATE_ROUTES } from '../../routes'
import TalentLayout from './TalentLayout'
import TalentPeoplePage from './TalentPeoplePage'
import Jobs from '../jobs'
import JobApplication from '../jobApplications'
import Candidate from '../candidate'
import CreateCandidateView from '../candidate/components/view/create-candidate-view'
import EditCandidateView from '../candidate/components/view/edit-candidate-view'

const TalentRouter = () => (
    <Routes>
        <Route element={<TalentLayout />}>
            <Route
                index
                element={<Navigate to={PRIVATE_ROUTES.jobs} replace />}
            />
            <Route path="people" element={<TalentPeoplePage />} />
            <Route path="jobs" element={<Jobs />} />
            <Route
                path="jobs/:id/applications"
                element={<JobApplication />}
            />
            <Route path="candidates" element={<Candidate />} />
            <Route
                path="candidates/create"
                element={<CreateCandidateView />}
            />
            <Route path="candidates/:id" element={<EditCandidateView />} />
            <Route
                path="*"
                element={<Navigate to={PRIVATE_ROUTES.jobs} replace />}
            />
        </Route>
    </Routes>
)

export default TalentRouter
